import { render, staticRenderFns } from "./mctrade-return.vue?vue&type=template&id=b6c5e47e&"
import script from "./mctrade-return.ts?vue&type=script&lang=ts&"
export * from "./mctrade-return.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports